import PageMixins from '../../components/_mixins/pages'
import ReservationMixins from '../../components/_mixins/event-reservation'
import StepsMixins from './steps'
import ReservationLocalMixins from './reseravtion'
export const mixins = [
  ReservationMixins,
  ReservationLocalMixins,
  PageMixins,
  StepsMixins
]

import WouldYouLikeTo from '../../components/parts/would-you-like-to'
import AgreeToTerms from '../../components/parts/AgreeToTerms'
import TimeslotSelectorBox from './parts/timeslot-selector-box'
import MiniCart from './parts/mini-cart'
import {Datetime} from 'vue-datetime-extended'
import 'vue-datetime-extended/dist/vue-datetime-extended.css'

export const components = {
  AgreeToTerms,
  Datetime,
  TimeslotSelectorBox,
  MiniCart,
  WouldYouLikeTo
}

export const EventBus = window.VueEventBus
export const RESERVATION_TYPE = 'axe-throwing'

export default {
  EventBus,
  mixins,
  components,
  RESERVATION_TYPE
}
